import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setDispositionChoice, setDispositionSubChoice } from 'Store/OrderManagement/DispositionChoice/DispositionChoiceAction';
import { GET_DISPOSITION_CHOICE, GET_DISPOSITION_SUB_CHOICE } from 'Store/OrderManagement/DispositionChoice/DispositionChoiceType';
import { apiMethod, apiType, API_URL } from 'utils';
import OrderManagementApiService from './OrderManagementApiService';
import { IPayload } from 'Model/IPayload';

function* getDispositionChoice(payload?: any): any {

    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.OrderManagement,
        endpoint :payload?.isLeased != undefined ?(`orders/disposition/dispositionChoices?isLeased=${payload?.isLeased}`) : (`orders/disposition/dispositionChoices`),
        payload : null
    }
    try {

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );

        if (response) {
            yield put(setDispositionChoice(response));
        }

    } catch (error) {
        yield put(setDispositionChoice([]))
    }
}

function* getDispositionSubChoice(dispositionTypeId: any): any {

    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.OrderManagement,
        endpoint : `orders/disposition/dispositionSubTypes/${dispositionTypeId.dispositionTypeId}`,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Disposition Sub Choice...."));

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setDispositionSubChoice(response));
        } else {
            yield put(setDispositionSubChoice([]));
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setDispositionSubChoice([]))
        yield put(globalLoaderText(""));
    }
}

function* watchDispositionChoice() {
    yield takeEvery(GET_DISPOSITION_CHOICE, getDispositionChoice);
    yield takeEvery(GET_DISPOSITION_SUB_CHOICE, getDispositionSubChoice);
}

export default function* combinedSaga() {
    yield all([
        watchDispositionChoice()
    ])
}
